
export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
    fieldName: {
      type: String,
      required: true,
      default: "profile_id",
    },
  },

  data() {
    return {
      isValid: false,
      loading: false,

      form: {
        id: null,
        text: "",
      },

      textRules: [(v) => !!v || this.$t("validations.field-is-required")],
    };
  },

  methods: {
    clear() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },

    close() {
      this.clear();
      this.$emit("close");
    },

    async sendMessage() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.form.id = this.profileId;

        try {
          const response = await this.$axios.post("/api/messages/add", {
            [this.fieldName]: this.id,
            text: this.form.text,
          });
          if (response.status === 200) {
            this.$notify({
              type: "success",
              message: this.$t("message-sent-successfully"),
            });
            this.close();
          }
        } catch (error) {
          console.log(error);
          this.$notify({
            type: "error",
            message: this.$t("something-went-wrong"),
          });
        } finally {
          this.loading = false;
        }
      }
    },
  },
};
